import {Injectable, signal} from '@angular/core';
import {RecordCalendarFileParams} from "../../../../types/file.types";

@Injectable({
  providedIn: 'root'
})
export class SingleFilesParamsService {
  private _singleFilesParams = signal<Array<RecordCalendarFileParams>>([]);
  public singleFilesParams = this._singleFilesParams.asReadonly();

  public updateFilesData(recordCalendarFileParams: RecordCalendarFileParams): void {
    this._singleFilesParams.update(current => {
      const newValue = [...current];
      newValue.push(recordCalendarFileParams);

      return newValue;
    });
  }

  public deleteFilesData(id: number): void {
    this._singleFilesParams.update(current => {
      return current.length ?
        current.filter(item => item.id !== id) :
        [];
    });
  }

  public resetFilesData(): void {
    this._singleFilesParams.set([]);
  }
}
